import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const roles = route.data.roles as Array<string>;
    if (this.authService.hasAtLeastOneOfGivenRoles(roles)) {
      return true;
    } else {
      this.router.navigate(['unauthorized']);
      return false;
    }
  }
}
